const baseUrl = '';

const imagePaths = {
    income: `${baseUrl}/logo_admin/income.png`,
    orders: `${baseUrl}/logo_admin/orders.png`,
    orderActive: `${baseUrl}/logo_admin/order-active.png`,
    user: `${baseUrl}/logo_admin/user.png`,
};

export default imagePaths;